import * as Yup from 'yup';
import { ObjectShape } from 'yup/lib/object';

import { IMethod } from '~/models/Method';

export const MethodSchema = (seriesNumber: number) => {
  const NameOfSerie: ObjectShape = {};
  const RepetitionsSerie: ObjectShape = {};
  const ActionTimeSerie: ObjectShape = {};
  const TimeOfRecoverySerie: ObjectShape = {};

  // eslint-disable-next-line no-plusplus
  for (let index = 0; index < seriesNumber; index++) {
    const elementIndex = index + 1;
    NameOfSerie[`name_of_serie_${elementIndex}`] = Yup.string().required(
      `Nome da série ${elementIndex} necessária.`,
    );
    RepetitionsSerie[
      `repetitions_serie_${elementIndex}`
    ] = Yup.string().required(
      `Quantidade de repetições da série ${elementIndex} necessária.`,
    );
    ActionTimeSerie[
      `action_time_serie_${elementIndex}`
    ] = Yup.string().required(
      `Tempo de ação da série ${elementIndex} necessária.`,
    );

    if (!(index === seriesNumber - 1)) {
      TimeOfRecoverySerie[
        `time_of_recovery_serie_${elementIndex}`
      ] = Yup.string().required(
        `Tempo de intervalo da série ${elementIndex} necessária.`,
      );
    }
  }

  return Yup.object().shape({
    tranning_method: Yup.string().required('Nome do método necessário.'),
    execution: Yup.string().required('Execução necessária.'),
    technical_description: Yup.string().required(
      'Descrição técnica necessária.',
    ),
    method_principle: Yup.string().required('Princípio ativo necessário.'),
    series_number: Yup.string().required(
      'Selecione pelo menos a quantidade de séries.',
    ),
    // total_action: Yup.string().matches(
    //   /([01]?[0-9]|2[0-3]):[0-5][0-9]:[0-5][0-9]/,
    //   'Tempo total de ação inválido, verifique os campos de tempo de ação se estão corretos',
    // ),
    // total_time: Yup.string().matches(
    //   /([01]?[0-9]|2[0-3]):[0-5][0-9]:[0-5][0-9]/,
    //   'Tempo total inválido, verifique os campos de tempo de ação e tempo de recuperação total',
    // ),
    // interval_recovery_total: Yup.string().matches(
    //   /([01]?[0-9]|2[0-3]):[0-5][0-9]:[0-5][0-9]/,
    //   'Tempo de recuperação total inválido, verifique os campos de tempo de recuperação em cada série',
    // ),
    volume_total: Yup.number()
      .typeError('Volume total inválido')
      .positive()
      .required('Volume total necessário.'),
    recovery_interval_between_series: Yup.string().required(
      'Intervalo de recuperação entre séries necessária.',
    ),
    series_names: Yup.object().shape(NameOfSerie),
    series_number_of_repetitions: Yup.object().shape(RepetitionsSerie),
    series_actions_time: Yup.object().shape(ActionTimeSerie),
    series_recovery_Time: Yup.object().shape(TimeOfRecoverySerie),
  });
};
